import { render, staticRenderFns } from "./CopyPasteTableInput.vue?vue&type=template&id=c90b516a&scoped=true"
import script from "./CopyPasteTableInput.vue?vue&type=script&lang=ts"
export * from "./CopyPasteTableInput.vue?vue&type=script&lang=ts"
import style0 from "./CopyPasteTableInput.vue?vue&type=style&index=0&id=c90b516a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90b516a",
  null
  
)

export default component.exports